/*
 * @Description: 价格文本
 * @Author: oubu
 * @Date: 2020-03-19
 */
import React, { Component } from 'react';
import './index.less';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import Util from 'utils';
import cx from 'classnames';
import Stores from 'config/Stores';

export default class PriceTextView extends Component {
  static propTypes = {
    value: PropTypes.string || PropTypes.number,
    showSymbol: PropTypes.bool,
    showLessZero: PropTypes.bool,
    showIcon: PropTypes.bool,
    iconValue: PropTypes.string,
    symbolClassName: PropTypes.string,
    unitClassName: PropTypes.string,
    integerClassName: PropTypes.string,
    decimalClassName: PropTypes.string,
    exchangeRate: PropTypes.number,
    currencySymbol: PropTypes.string,
    ignoreExchange: PropTypes.bool
  };

  static defaultProps = {
    value: 0,
    showSymbol: true,
    showIcon: true,
    showLessZero: false,
    iconValue: '', // 默认为空，将根据语言动态获取
    symbolClassName: '', // 符号部分样式
    unitClassName: '', // 单位部分样式
    integerClassName: '', // 整数部分样式
    decimalClassName: '', // 小数部分样式
    exchangeRate: undefined,
    currencySymbol: undefined,
    ignoreExchange: false,
    isSelectMall: false, // 甄选商品
    showCurrencyName: false, // 是否显示货币名称
    showMinus: true // 是否显示负号
  };

  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  getCurrencySymbol() {
    // 如果父组件传递了currencySymbol，则使用传递的值

    if (this.props.currencySymbol !== undefined && this.props.currencySymbol !== '') {
      return this.props.currencySymbol;
    }
    // 如果父组件传递了iconValue，则使用传递的值
    if (this.props.iconValue !== '') {
      return this.props.iconValue;
    }
    // 动态获取当前语言的货币符号
    const appMod = Stores.AppMod;
    if (!this.props.currencySymbol && appMod) {
      return appMod.currencySymbol || '¥';
    }
    // 默认回退到人民币符号
    return '¥';
  }

  render() {
    const {
      value,
      showSymbol,
      className,
      symbolClassName,
      unitClassName,
      integerClassName,
      decimalClassName,
      showIcon,
      hidePoint,
      showLessZero,
      tail,
      ignoreExchange,
      exchangeRate,
      currencySymbol,
      isSelectMall = false,
      showCurrencyName = false, // 是否显示货币名称
      showMinus = true, // 是否显示负号
      currencyCode = '' // 货币代码
    } = this.props;

    // 第一步：去除首尾空格 → 结果是 "¥ 189.0000"（中间的空格没被过滤）
    let formatValue = String(value).replace(/(^\s*)|(\s*$)/g, '');

    // 第二步：判断 isNaN("¥ 189.0000") → 结果是 true（因为包含非数字字符¥）
    if (isNaN(formatValue) || !formatValue) {
      formatValue = 0; // 直接被赋值为 0
    }

    // 第三步：最终 formatValue = 0.toFixed(2) → "0.00"
    formatValue = parseFloat(formatValue).toFixed(2);
    let symbol = formatValue >= 0 ? '+' : '-';
    if (showLessZero) {
      symbol == '+' && (symbol = '');
    }
    if (formatValue < 0) {
      formatValue = formatValue.replace('-', '');
    }
    const pureNum = String(value).replace(/[^\d.-]/g, '');
    if (!ignoreExchange) {
      formatValue = Util.formatMoney({
        value: pureNum,
        showPrefix: false,
        ignoreExchange,
        exchangeRate,
        currencySymbol,
        showCurrencyName,
        currencyCode
      });
    }

    if (ignoreExchange || isSelectMall) {
      formatValue = value;
    }
    // formatValue = typeof value === 'string' ? value : formatValue.split('.');
    if (typeof value === 'string') {
      formatValue = value;
    } else {
      formatValue = String(formatValue).split('.');
      if (!showMinus && /^[+-]/.test(formatValue[0])) {
        formatValue[0] = formatValue[0].replace(/^[+-]/, '');
      }
    }

    const currencySymbolDisplay = this.getCurrencySymbol();
    const returnPrice = () => {
      if (isSelectMall) {
        // 甄选商品不转换
        return formatValue;
      }
      return typeof value === 'string' ? value : formatValue[0] || formatValue;
    };
    return (
      <Flex className={cx('common-price-text', className)} align="baseline">
        {showSymbol && (
          <span className={cx('size-small', 'symbol', symbolClassName)}>
            {typeof value !== 'string' ? symbol : ''}
          </span>
        )}
        {showIcon && typeof value !== 'string' && currencySymbolDisplay && (
          <span className={cx('size-small', 'unit', unitClassName)}>
            {typeof value !== 'string' ? currencySymbolDisplay : ''}
          </span>
        )}
        {returnPrice() && <span className={cx('size-big', integerClassName)}>{returnPrice()}</span>}
        {!hidePoint && Array.isArray(formatValue) && formatValue.length > 1 && formatValue[1] && (
          <span className={cx('size-small', decimalClassName)}>.{formatValue[1]}</span>
        )}
        {tail && tail}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/PriceText/index.js